import React, { useCallback, useEffect, useRef, useState } from 'react';
import MediaQuery from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';
import {useLocation} from "react-router";
import { Link } from 'react-router-dom';
import { isObjectEmpty } from 'Utils';

// COMPONENTS
import CheckoutDeliveryAddress from 'components/Checkout/CheckoutDeliveryAddress/CheckoutDeliveryAddress';
import CheckoutFreight from 'components/Checkout/CheckoutFreight/CheckoutFreight';
import CheckoutPayment from 'components/Checkout/CheckoutPayment/CheckoutPayment';
import CheckoutPersonalData from 'components/Checkout/CheckoutPersonalData/CheckoutPersonalData';
import CheckoutSummary from 'components/Checkout/CheckoutSummary/CheckoutSummary';
import CheckoutVoucher from 'components/Checkout/CheckoutVoucher/CheckoutVoucher';
import ToastAlert from 'components/ToastAlert/ToastAlert';
import ToastErrorAlert from 'components/ToastAlert/ToastErrorAlert';

// DS
import { VertContainer, Col, VertAlert, VertTypography } from '@vertem-core/vertice-ds';

// SERVICES
import PipeProvider from 'Services/Providers/PipeProvider';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';

// STYLES
import 'Assets/styles/default/pages/checkout/CheckoutStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';
import ynToBool from 'Utils/ynToBool';
import { addDimensionsCartGTM } from 'Shared/dataLayer/dataLayer';
import { setErrorCheckout } from 'redux/Reducers/Shipping/ShippingSlice';
import { handleObjectAddress } from 'Utils/handleObjectAddress';
import { CheckoutModal2FA } from 'components/2FA/CheckoutModal2FA';
import CheckoutProvider from 'components/Checkout/CheckoutProvider';
import { setVirtualVoucher } from 'redux/Reducers/Cart/CartTableReducer';
import validatePhoneNumber from 'Utils/validatePhoneNumber';
import { setErrorPhoneNumber } from 'redux/Reducers/Shipping/ShippingSlice';
import useGa from "Utils/Ga";
import getNameOfVendor from "Utils/getNameOfVendor";
import { handleIsValidAddressCheckout } from 'Utils/handleIsValidAddressCheckout';
import { getFirstParticipantPhone } from 'Utils/getFirstParticipantPhone';
import { pointsMask } from 'Utils/commons/points';
import OnboardingRedirectModal from 'components/Onboarding/OnboardingRedirectModal';

// CHECKOUT PAGE
const CheckoutPage = () => {
  /* Hooks */
  // @ts-ignore
  const { eventGa } = useGa()
  const dispatch = useDispatch();
  const { callApi } = usePipeContext();
  const braspagRef = useRef();
  const [braspagError, setBraspagError] = useState(null);
  const Participants = useSelector(({ Participants: data }) => data);
  const phone = getFirstParticipantPhone(Participants.phones);

  const Shipping = useSelector(({ Shipping: data }) => data);
  const Cart = useSelector(({ Cart: data }) => data);
  const Catalog = useSelector(({ Catalog: data }) => data)
  const PaymentConfig = useSelector(({ PaymentConfig: data }) => data);
  const CreatePurchase = useSelector(({ CreatePurchase: data }) => data);
  const ShippingCart = useSelector(({ Shipping: data }) => data);
  const CartSlice = useSelector(({ ShippingSlice: data }) => data.cart);
  const Balance = useSelector(({ Balance: data }) => data);
  const { total: TotalCart } = CartSlice;
  const { pointsValue } = Balance;

  const {
    CreatePurchase: { status: statusCode },
  } = useSelector(({ CreatePurchase }) => ({ CreatePurchase }));

  /* States */
  const [hasInfosAlert, setHasInfosAlert] = useState(false);
  const [hasCartError, setHasCartError] = useState(false);
  const [hasBalanceInsufficient, setHasBalanceInsufficient] = useState({});
  const {
    currencyConfiguration: { pointsName, decimalPlaces },
  } = Catalog;
  const [errorPointsCash, setErrorPointsCash] = useState({});
  const [errorAddress, setErrorAddress] = useState(null);
  const [errorPhone, setErrorPhone] = useState(null);
  const [hasErrorAddress, setHasErrorAddress] = useState(false);
  const Stores = useSelector(({ Stores }) => Stores)
  const [hasVouchersExternalInCart, setHasVouchersExternalInCart] =
    useState(false);
  const [createOrderActive, setCreateOrderActive] = useState(false);

  const [paymentInfos, setPaymentInfos] = useState({
    isValid: null,
    installments: null,
    installmentValue: null,
    pointsValue: null,
    pointsSelected: null,
    cashSelected: null,
  });

  const [showOnboardingModal, setShowOnboardingModal] = useState(false);

  const {updatedSuccessfully} = Shipping

  useEffect(() => {
    if (TotalCart === undefined || pointsValue === undefined) return;

    if (pointsValue < TotalCart) {
      const pointsToFinish = TotalCart - pointsValue;
      const formattedTotalValue = pointsMask(
        pointsToFinish,
        decimalPlaces,
        pointsName
      );



      setHasBalanceInsufficient({
        message: `Para concluir seu resgate, são necessários mais ${formattedTotalValue.value} ${formattedTotalValue.label}.`,
      });
      return;
    }
    setHasBalanceInsufficient(null);

  }, [TotalCart, pointsValue]);
  /* Vars */
  const { cart } = Cart;
  const { paymentConfig: PointsAndCashConfig } = PaymentConfig;
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const onBoardingRequired = statusCode === "MessageOnBoardingRequired";

  /* Handlers */
  const handlePaymentsInfos = (infos) => {
    setPaymentInfos(infos);
  };

  const handleSetBraspagError = useCallback(


    (err) => {
      setBraspagError(err);
    },
    [braspagError]
  );

  const addressIsValid = useCallback(() => {
    let response = true;

    if (
      !Participants?.address?.zipCode ||
      (Participants?.address?.zipCode &&
        !Participants?.address?.zipCode?.value &&
        !Participants?.address?.zipCode?.disabled)
    ) {
      response = false;
    } else if (
      (!Participants?.address?.city?.value &&
        !Participants?.address?.city?.disabled) ||
      (!Participants?.address?.state?.value &&
        !Participants?.address?.state?.disabled) ||
      (!Participants?.address?.addressText?.value &&
        !Participants?.address?.addressText?.disabled)
    ) {
      response = false;
    }

    return response;
  }, [
    Participants?.address?.zipCode,
    Participants?.address?.city,
    Participants?.address?.state,
    Participants?.address?.addressText,
    Participants?.address?.zipCode?.value,
    Participants?.address?.zipCode?.disabled,
    Participants?.address?.city?.value,
    Participants?.address?.city?.disabled,
    Participants?.address?.state?.value,
    Participants?.address?.state?.disabled,
    Participants?.address?.addressText?.value,
    Participants?.address?.addressText?.disabled,
  ]);
  useEffect(() => {
    const allItemsAreExternalVoucherVirtual = cart?.items?.every(
      (item) => item.vendor && item.vendor.type === 'EXTERNALVOUCHERVIRTUAL'
    );

    const hasOnlyExternalVoucherVirtualItems =
      cart?.items?.length > 0 && allItemsAreExternalVoucherVirtual;

    if (hasOnlyExternalVoucherVirtualItems) {
      dispatch(setVirtualVoucher(true));
      setHasVouchersExternalInCart(true);
      return;
    }
    dispatch(setVirtualVoucher(false));
    setHasVouchersExternalInCart(false);
  }, [cart.items]);

  useEffect(() => {
    const {areaCode, number , type} = phone || {};
    const validatePhone = validatePhoneNumber({ areaCode, number }, type);
    let hasErrorPhone = false;

    if (!validatePhone) {
      setErrorPhone({
        error: {
          message: (
            <>
              O número de telefone informado parece estar incompleto ou
              incorreto. Por favor, confira e atualize para continuarmos.
            </>
          ),

          subMessage: null,
        },
      });
      hasErrorPhone = true;
      dispatch(setErrorPhoneNumber(hasErrorPhone));
      return;
    }
    hasErrorPhone = false;
    dispatch(setErrorPhoneNumber(hasErrorPhone));
    setErrorPhone(null);
  }, [phone?.areaCode, phone?.number, phone?.type]);

  useEffect(() => {
    if (ShippingCart?.hasError) {
      setErrorAddress({
        error: {
          message: (
            <>
              Há um problema com seu endereço, atualize{' '}
              <Link to={'/profile'}>clicando aqui</Link>, para garantir suas
              entregas. Caso o contrário não poderemos continuar com o seu
              processo de resgate.
            </>
          ),
          subMessage: null,
        },
      });
      setHasErrorAddress(true);
      return;
    }
    setHasErrorAddress(false);
  }, [ShippingCart?.hasError]);

  useEffect(() => {
    const combinedAddress = handleObjectAddress(Cart, Participants);

    const complement = get(combinedAddress?.complement, 'value');

    const district = get(combinedAddress?.district, 'value');
    const number = get(combinedAddress?.number, 'value');

    const isValidAddressCheckout =
      handleIsValidAddressCheckout(combinedAddress);

    if (
      (((complement && complement?.length > 20) ||
        (district && district?.length > 20) ||
        isEmpty(number)) &&
        !ShippingCart?.hasError) ||
      (Participants?.address &&
        Participants?.address?.zipCode?.value === '00000000') ||
      !isValidAddressCheckout
    ) {
      //  VALIDA SE O ENDEREÇO ESTÁ COMPLETO E MESMA LOGICA DE BLOQUEIO DO BOTÃO DE FINALIZAR COMPRA
      setErrorAddress({
        error: {
          message: (
            <>
              Há um problema com seu endereço, atualize{' '}
              <Link to={'/profile'}>clicando aqui</Link>, para garantir suas
              entregas. Caso o contrário não poderemos continuar com o seu
              processo de resgate.
            </>
          ),
          subMessage: null,
        },
      });
      setHasErrorAddress(true);
      return;
    }
    setHasErrorAddress(false);
  }, [
    Participants?.address,
    Participants?.address?.complement,
    Participants?.address?.district,
    Participants?.address?.complement?.value,
    Participants?.address?.district?.value,
    Participants?.address?.number,
    ShippingCart?.hasError,
  ]);

  /* Utils */
  const hasError = () => {
    if (ShippingCart?.error && !isObjectEmpty(ShippingCart?.error)) {
      setHasCartError(true);
      return true;
    }
    if (Cart?.error && !isObjectEmpty(Cart?.error)) {
      setHasCartError(true);
      return true;
    }
    if (CreatePurchase?.error && !isObjectEmpty(CreatePurchase?.error)) {
      setHasCartError(true);
      return true;
    }

    if (!addressIsValid()) {
      setErrorAddress({
        error: {
          message: (
            <>
              Há um problema com seu endereço, atualize{' '}
              <Link to={'/profile'}>clicando aqui</Link>, para garantir suas
              entregas. Caso o contrário não poderemos continuar com o seu
              processo de resgate.
            </>
          ),
          subMessage: null,
        },
      });
      setHasErrorAddress(true);
      return true;
    }

    if (PointsAndCashConfig?.error && PointsAndCashConfig?.error.length > 0) {
      const objectError = {
        error: {
          message: PointsAndCashConfig.error[0],
          subMessage: '#DoNotShowDescription',
        },
      };

      setErrorPointsCash(objectError);
      setHasCartError(true);
      return true;
    }
    setHasCartError(false);
    return false;
  };

  /* Lifecycles */
  useEffect(() => {
    if (
      PaymentConfig?.finishRequests ||
      Cart?.cartFinishRequests ||
      ShippingCart?.finishRequests ||
      CreatePurchase?.finishRequests
    ) {
      hasError();
    }
  }, [
    PaymentConfig?.finishRequests,
    Cart?.cartFinishRequests,
    ShippingCart?.finishRequests,
    CreatePurchase?.finishRequests,
  ]);

  useEffect(() => {
    hasError();
  }, []);
  useEffect(() => {
    if (
      Shipping &&
      !Shipping.isLoading &&
      Shipping.cep &&
      Shipping.cep !== '00000000' &&
      !Shipping.value.vendors &&
      Participants &&
      Participants.address &&
      Participants.address.zipCode.value !== '00000000'
    ) {
      const aliasProviderUUID = generateUUID();
      callApi({
        symbol: `FETCH_CART_SHIPPING`,
        alias: aliasProviderUUID,
        payload: {
          zipCode:
            (Shipping && Shipping.cep) || Participants.address.zipCode.value,
        },
      });
    }
  }, [Shipping, Participants]);

  useEffect(() => {
    if (
      Shipping &&
      Participants &&
      Participants.address &&
      Participants.address.zipCode &&
      Participants.address.zipCode.value !== '00000000' &&
      ((Shipping.value &&
        !Shipping.isLoading &&
        !Shipping.value.code &&
        !Shipping.value.city) ||
        (!Shipping.value && !Shipping.isLoading))
    ) {
      const aliasProviderUUID = generateUUID();
      callApi({
        symbol: `FETCH_ADDRESS_SHIPPING`,
        alias: aliasProviderUUID,
        payload: {
          zipCode:
            (Shipping && Shipping.cep) || Participants.address.zipCode.value,
        },
      });
    }
  }, [Shipping, Participants]);

  useEffect(() => {
    // TRATATIVA PARA ENDEREÇO INVÁLIDO #1 - ESTADO RESPONSAVEL POR BLOQUEAR O BOTÃO DE FINALIZAR COMPRA
    dispatch(setErrorCheckout(hasErrorAddress));
  }, [hasErrorAddress]);

  useEffect(() => {
    if (braspagRef && braspagRef.current && braspagError) {
      window.scroll(0, 0);
    }
  }, [braspagRef, braspagError]);

  useEffect(() => {
    const cartItems = Cart?.cart?.items || [];
    if (cartItems) {
      addDimensionsCartGTM(cartItems, 2);
    }
  }, []);

  useEffect(() => {
    if (Cart && !Cart.isLoading && Stores && Stores?.ecommerce && Stores?.ecommerce.length > 0) {
      const itemsCartReducer = Cart
      eventGa("begin_checkout", {
        currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
        value: parseFloat(itemsCartReducer?.cart?.price),
        items: itemsCartReducer?.cart?.items.map(({ vendor, sku, name, price, quantity, category }) => ({
          item_id: sku,
          item_name: name,
          currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
          item_brand: getNameOfVendor(vendor.id, vendor.type, Stores)?.name,
          item_category: category.name,
          price: parseFloat(price),
          quantity
        }))
      })
    }
  }, [ Cart, Stores, Catalog ])

  useEffect(() => {
    if (Shipping.finishRequests && Cart && Cart?.cart?.items?.length) {
      const itemsCartReducer = Cart
      eventGa("add_shipping_info", {
        shipping_tier: "Correios",
        currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
        value: parseFloat(itemsCartReducer?.cart?.price),
        items: itemsCartReducer?.cart?.items.map(({ vendor, sku, name, price, quantity, category }) => ({
          item_id: sku,
          item_name: name,
          currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
          item_brand: getNameOfVendor(vendor.id, vendor.type, Stores)?.name,
          item_category: category.name,
          price: parseFloat(price),
          quantity
        }))
      })
    }
  }, [ Cart, Shipping, Catalog ]);

  useEffect(() => {
    if (CreatePurchase?.status === "MessageOnBoardingRequired") setShowOnboardingModal(true);
  }, [CreatePurchase?.error]);

  /* Renders */
  if (
    !Shipping ||
    !Shipping.value ||
    Shipping.isLoading ||
    !Shipping.value.vendors
  )

    return null;
  return (
    <PipeProvider
      apiSymbols={[
        'FETCH_CATALOG',
        'LOAD_BALANCE',
        'FETCH_PARTICIPANT',
        'FETCH_STORES',
        'FETCH_CART',
      ]}
    >
      <CheckoutProvider>
        <VertContainer className="checkout-page-wrapper">
          <Col className="checkout-page">
            <Col className="checkout-page-content-wrapper col">
              {(() => {
                if (onBoardingRequired)
                  return (
                    <OnboardingRedirectModal 
                      open={showOnboardingModal}
                      handleClose={() => setShowOnboardingModal(false)}
                    />
                  );
                return (
                  <>
                    {hasInfosAlert && (
                      <ToastAlert
                        size="small"
                        message="Adicione um endereço de entrega para continuar com seu resgate."
                      />
                    )}
                    {errorPhone && (
                      <ToastErrorAlert
                        error={errorPhone}
                        className={`margin-bottom-small`}
                      />
                    )}

                    {hasErrorAddress && (
                      <ToastErrorAlert
                        error={errorAddress}
                        className={`margin-bottom-small`}
                      />
                    )}

                    {hasCartError && (
                      <>
                        <ToastErrorAlert
                          error={
                            PaymentConfig.paymentConfig ||
                            CreatePurchase?.error ||
                            ShippingCart?.error ||
                            Cart?.error ||
                            errorPointsCash
                          }
                          className={`margin-bottom-small`}
                        />
                      </>
                    )}
                  </>
                );
              })()}
              {(() => {
                if (!braspagError) return null;
                return (
                  <div ref={braspagRef}>
                    <ToastErrorAlert
                      error={{ error: { message: braspagError } }}
                      className={`margin-bottom-small`}
                    />
                  </div>
                );
              })()}

              {hasBalanceInsufficient && (
                <VertAlert
                  type="error"
                  className="toast-alert"

                  message={hasBalanceInsufficient.message}
                  closable={false}
                />
              )}

              {ynToBool(Cart?.hasItemsVirtualVoucher) &&
                hasVouchersExternalInCart ? (
                <CheckoutVoucher
                  hasItemsVirtualVoucher={Cart?.hasItemsVirtualVoucher}
                  emailToSend={
                    cart?.customer?.email || Participants?.email?.value
                  }
                />
              ) : (
                <>
                  <CheckoutPersonalData
                    personType={
                      Participants.personType || cart?.customer?.personType
                    }
                    name={cart?.customer?.name || Participants?.name?.value}
                    document={
                      cart?.customer?.documentNumber ||
                        Participants.personType === 1
                        ? Participants?.cpf?.value
                        : Participants?.cpfCnpj?.value
                    }
                    partnerCpf={Participants?.partnerCpf?.value}
                    ie={Participants?.ie?.value}
                    email={cart?.customer?.email || Participants?.email?.value}
                    phone= {`${phone?.areaCode} ${phone?.number}`}
                    setHasInfosAlert={setHasInfosAlert}
                  />

                  {
                    ynToBool(!process.env.REACT_APP_HIDE_CHECKOUT_DELIVERY_ADDRESS) && (
                      <CheckoutDeliveryAddress
                        addressInvalid={!addressIsValid()}
                        setHasInfosAlert={setHasInfosAlert}
                      />
                    )
                  }
                </>
              )}
              {Shipping &&
                Shipping?.zipCode !== '00000000' &&
                Participants &&
                Participants.address.zipCode.value !== '00000000' && (
                  <CheckoutFreight />
                )}
              {Participants &&
                Participants.address.zipCode.value !== '00000000' && updatedSuccessfully && (
                  <CheckoutPayment
                    handlePaymentsInfos={handlePaymentsInfos}
                    createOrderActive={createOrderActive}
                    setCreateOrderActive={setCreateOrderActive}
                    onBraspagError={handleSetBraspagError}
                  />
                )}
            </Col>

            <MediaQuery minWidth={769}>
              <Col className="checkout-page-summary-wrapper">
                <CheckoutSummary
                  setCreateOrderActive={setCreateOrderActive}
                  {...paymentInfos}
                />
              </Col>
            </MediaQuery>
          </Col>
        </VertContainer>
        <CheckoutModal2FA />
      </CheckoutProvider>
    </PipeProvider>
  );
};

export default CheckoutPage;
